import labelInputMixin from "../_mixin";
export default {
  name: "LabelDatePicker",
  mixins: [labelInputMixin],
  methods: {
    renderInput(h, data) {
      return h("el-date-picker", data);
    }
  },
  mounted() {
    document.querySelectorAll('.el-icon-date').forEach(item => item.style = `display: none`)
    document.querySelectorAll('.el-range-separator').forEach(item => item.style = `display: none`)
  }
};
